import React, { FC } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { CatalogueRoute } from './CatalogueRoute'
import { Box } from '@chakra-ui/core'
import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    analytics: any
  }
}

export const Routes: FC = () => {
  return (
    <Box
      width={['100%', '425px']}
      height={['100%', '720px']}
      alignSelf="center"
      margin="auto"
      shadow={['unset', 'rgba(194, 194, 194, 0.75) 3px 9px 17px 1px;']}
    >
      <Router history={history}>
        <Switch>
          <Route path="/:customer/:order">
            <CatalogueRoute />
          </Route>
        </Switch>
      </Router>
    </Box>
  )
}
